import React, { useContext } from "react";
import logo from "../../assets/images/redlogo.png";
import { ReactComponent as SmsIcon } from "../../assets/icons/sms.svg";
import * as Yup from "yup";
import {
  Alert,
  Button,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import { PreferencesContext } from "../../PreferenceContext";
import { LoadingButton } from "@mui/lab";
import { useAuth0 } from "@auth0/auth0-react";
import { ForgotPasswordEmail } from "../../service/AuthService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import LayoutBg from "../../assets/images/layoutBg.png";

// ✅ Validation Schema
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required("Email is required.")
    .email("Enter a valid email."),
});

type FormValues = {
  email: string;
};

export default function ForgotPassword() {
  const [loading, setLoading] = React.useState(false);
  const { updateUserContext } = useContext(PreferencesContext);
  const [showAlert, setAlertMessage] = React.useState({
    isVisible: false,
    type: "",
    message: "",
  });

  // const { logout } = useAuth0();
  // logout();

  // ✅ useForm instead of Formik
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: { email: "" },
  });

  // ✅ Submit handler
  async function submitForgotPasswordForm(values: FormValues) {
    setLoading(true);
    try {
      const user: any = await ForgotPasswordEmail({ email: values.email });

      if (user) {
        setAlertMessage({
          isVisible: true,
          type: "success",
          message:
            "Email sent successfully, please check your inbox to find reset password link.",
        });
      } else {
        setAlertMessage({
          isVisible: true,
          type: "error",
          message: "User not found",
        });
      }
    } catch (error: any) {
      setAlertMessage({
        isVisible: true,
        type: "error",
        message: error?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
      setTimeout(() => {
        setAlertMessage({ isVisible: false, type: "", message: "" });
      }, 7000);
      reset(); // ✅ reset form
    }
  }

  return (
    <Grid
      container
      sx={{
        position: "relative",
        backgroundColor: "#E5E5E5",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        height: "100%",
        width: "100%",
        minWidth: "991px",
        alignItems: "center",
        minHeight: "100vh",

        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${LayoutBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.1,
          zIndex: 0,
        },

        "& > *": {
          position: "relative",
          zIndex: 1,
        },
      }}
    >
      <Box>
        <Grid size={12} textAlign="center" mb={2}>
          <a href="https://www.stakeholdermaps.com/">
            <img src={logo} alt="logo" style={{ maxWidth: 200 }} />
          </a>
        </Grid>
        <Paper elevation={0} className="paper-singin">
          <Grid sx={{ width: "100%", opacity: 1 }}>
            <form onSubmit={handleSubmit(submitForgotPasswordForm)}>
              <Box className="box-container forgot-password-wrapper">
                <Paper className="paper-container-forgot paper-wrapper">
                  {showAlert.isVisible && (
                    <Grid mb={1}>
                      <Alert severity={showAlert.type as any}>
                        {showAlert.message}
                      </Alert>
                    </Grid>
                  )}

                  <Grid
                  // className="forgot-password"
                  // sx={{ border: "1px solid green" }}
                  >
                    <Link className="backspace-Button" to={"/sign-in"}>
                      <KeyboardBackspaceIcon className="icon-css" />
                      <b>Back</b>
                    </Link>
                  </Grid>

                  <Typography sx={{ textAlign: "left" }} mt={3}>
                    Email address
                  </Typography>
                  <TextField
                    sx={{ mt: 1 }}
                    fullWidth
                    placeholder="name@company.com"
                    {...register("email")}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="start">
                    //       <SmsIcon stroke={"red"} />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />

                  <LoadingButton
                    color="primary"
                    sx={{
                      mt: 3,
                      backgroundColor: "#4C0808",
                      fontWeight: 400,
                      fontSize: "13px",
                      borderRadius: "4px",
                    }}
                    loading={loading}
                    loadingPosition="start"
                    variant="contained"
                    type="submit"
                  >
                    Submit
                  </LoadingButton>
                </Paper>
              </Box>
            </form>
          </Grid>
          {/* <Grid className="forget-img-wrapper"></Grid> */}
        </Paper>
      </Box>
    </Grid>
  );
}
